import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-interview')) {
  page()
}
function page() {
  let intOtherSwiper
  if (document.getElementById('intOther')) {
    // SP時だけスライダーにする
    if (window.matchMedia('(max-width:768px)').matches) {
      intOtherSwiperInit()
    }
    window.addEventListener('resize', function (e) {
      if (intOtherSwiper && window.matchMedia('(min-width:769px)').matches) {
        intOtherSwiper.destroy()
        intOtherSwiper = false
      } else if (!intOtherSwiper && window.matchMedia('(max-width:768px)').matches) {
        intOtherSwiperInit()
      }
    })
  }
  function intOtherSwiperInit() {
    const slideItem = document.getElementById('intOther')
    const sliderName = 'intOther'
    intOtherSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.2, //表示数変更
      spaceBetween: 30, //スライド同士の間隔を空ける
      centeredSlides: true, // 中央のスライドを基準にする
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}
